import { sizes as indicatorSizes } from './stepperIndicatorTheme'

const baseStyle = {
  desc: { color: 'sandstone.45' },
}

const defaultProps = {
  size: 'md',
}

export const variants = {
  active: {
    tailColor: 'seaBlue.main',
    iconTailColor: 'seaBlue.main',
    titleColor: 'sandstone.10',
    titleFontWeight: 600,
  },
  completed: { tailColor: 'landGreen.41', iconTailColor: 'landGreen.41', titleColor: 'sandstone.10' },
  optional: { tailColor: 'seaBlue.45', iconTailColor: 'seaBlue.45', titleColor: 'sandstone.10' },
  pending: { tailColor: 'sandstone.90', iconTailColor: 'sandstone.45', titleColor: 'sandstone.55' },
  error: {
    tailColor: 'energyRed.45',
    iconTailColor: 'energyRed.45',
    titleColor: 'energyRed.main',
    titleFontWeight: 600,
  },
}

export const sizes = {
  md: {
    title: { fontSize: '16px', pt: '4px' },
    indicatorWidth: indicatorSizes.md.width,
    vertTailWidth: '16px',
    desc: { fontSize: '14px' },
  },
  sm: {
    title: { fontSize: '14px', pt: '2px' },
    indicatorWidth: indicatorSizes.sm.width,
    vertTailWidth: '12px',
    desc: { fontSize: '12px' },
  },
} as const

export default {
  baseStyle,
  defaultProps,
  sizes,
  variants,
}
